<div class="nav-bar">
  <div class="logo-container" routerLink="">
    <img alt="" class="cc-logo" src="./assets/images/cc_logo.png">
    <span class="cc-text">{{getString('cheapcharts')}}</span>
  </div>
</div>
<p class="txt-algn-cntr">
  {{getString("crashErrorMessage")}}
</p>
